export enum PaymentGatewayType {
  Stripe = "Stripe",
  Moneris = "Moneris"
}
